import React from 'react';

interface BadgeIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const BadgeIcon: React.FC<BadgeIconProps> = ({
  width = 14,
  height = 17,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M6.74441 4.7696L4.10066 0.366474C3.89754 0.0289743 3.47254 -0.0929007 3.12254 0.0820993L0.416287 1.43522C0.0444122 1.6196 -0.105588 2.0696 0.0787872 2.44147L2.25379 6.78835C1.31316 7.84772 0.744412 9.24147 0.744412 10.7696C0.744412 14.0821 3.43191 16.7696 6.74441 16.7696C10.0569 16.7696 12.7444 14.0821 12.7444 10.7696C12.7444 9.24147 12.1725 7.84772 11.235 6.78835L13.41 2.44147C13.5944 2.0696 13.4444 1.6196 13.0757 1.43522L10.3663 0.0789743C10.0163 -0.0960257 9.58816 0.0289743 9.38816 0.363349L6.74441 4.7696ZM7.70691 9.22272C7.75066 9.31022 7.83191 9.3696 7.92566 9.3821L9.49129 9.61022C9.73191 9.6446 9.82566 9.93835 9.65379 10.1102L8.51941 11.2165C8.45066 11.2852 8.41941 11.379 8.43504 11.4758L8.70379 13.0352C8.74441 13.2727 8.49441 13.4571 8.27879 13.3446L6.87879 12.6071C6.79441 12.5633 6.69129 12.5633 6.60691 12.6071L5.20691 13.3446C4.99129 13.4571 4.74129 13.2758 4.78191 13.0352L5.05066 11.4758C5.06629 11.3821 5.03504 11.2852 4.96629 11.2165L3.83191 10.1102C3.65691 9.94147 3.75379 9.64772 3.99441 9.61022L5.56004 9.3821C5.65379 9.3696 5.73816 9.3071 5.77879 9.22272L6.47879 7.80397C6.58504 7.58522 6.89441 7.58522 7.00379 7.80397L7.70379 9.22272H7.70691Z"
      fill={color}
    />
  </svg>
);

export default BadgeIcon;
